export default __webpack_public_path__ + "fonts/kingvision_bg_inner.86a97a123fefea944867d322eb4a856b.png";